import { render, staticRenderFns } from "./History_internet.vue?vue&type=template&id=3457ec12&"
import script from "./History_internet.vue?vue&type=script&lang=js&"
export * from "./History_internet.vue?vue&type=script&lang=js&"
import style0 from "./History_internet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports